import MobiusTable, { alignment } from './MobiusTable';

export { alignment };
export default MobiusTable;
